"use client";

import Link from "next/link";
import { useEffect } from "react";

const KAYIT = "cerez-onay";

/** Tercihi yeniden açmak için (altbilgideki düğme bu olayı yayar). */
export const CEREZ_OLAY = "cerez-tercih-ac";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Çerez onayı — Google Consent Mode v2'ye bağlıdır.
 *
 * Bu banner yalnızca görsel değildir: seçim gtag('consent','update') ile
 * iletilir, böylece Google Analytics ve AdSense gerçekten kısıtlanır.
 * Varsayılan durum <head>'deki satır içi betikte 'denied' olarak kurulur
 * (bkz. layout.tsx → onayScript); burada yalnızca GÜNCELLEME yapılır.
 *
 * Reddetmek reklamları kaldırmaz, kişiselleştirmeyi durdurur.
 *
 * GÖRÜNÜRLÜK BURADA DEĞİL: işaretleme her zaman sunucu HTML'ine basılır,
 * görünürlüğü <html data-cerez> + globals.css çözer. Böylece banner ilk
 * boyamayla birlikte çıkar. Eskiden görünürlük React durumundaydı ve banner
 * ancak hidrasyondan sonra boyandığı için sayfanın LCP ögesi oluyordu
 * (mobilde 9.9 saniye render gecikmesi). Bu bileşenin işi artık yalnızca
 * kararı kaydetmek ve Google'a iletmek.
 */
export function CerezOnayi() {
  // Altbilgideki "çerez tercihleri" düğmesi banner'ı yeniden açar.
  useEffect(() => {
    const ac = () => {
      document.documentElement.dataset.cerez = "yok";
    };
    window.addEventListener(CEREZ_OLAY, ac);
    return () => window.removeEventListener(CEREZ_OLAY, ac);
  }, []);

  function karar(kabul: boolean) {
    const izin = kabul ? "granted" : "denied";
    try {
      localStorage.setItem(KAYIT, kabul ? "kabul" : "ret");
    } catch {
      // Yazılamazsa seçim bu oturum için geçerli olur, kalıcı olmaz.
    }
    window.gtag?.("consent", "update", {
      ad_storage: izin,
      ad_user_data: izin,
      ad_personalization: izin,
      analytics_storage: izin,
    });
    document.documentElement.dataset.cerez = "var";
  }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Çerez tercihi"
      /*
        position: fixed — düzenin akışına girmez, dolayısıyla CLS üretmez.
        Sayfa yüklenirken içerik kaymaz.
      */
      className="cerez-banner fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-surface/95 px-4 py-3 shadow-[0_-8px_24px_-12px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:p-4"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-2.5 sm:flex-row sm:items-center sm:gap-5">
        {/*
          Metin mobilde KISA tutulur. Uzun hâli 178px yer kaplıyordu — 844px
          ekranın %21'i; kullanıcı daha siteyi görmeden ekranın beşte birini
          banner'a veriyordu. Açıklayıcı cümle sm ve üstünde görünür.
        */}
        <p className="flex-1 text-[13px] leading-snug text-muted sm:text-sm sm:leading-relaxed">
          Ziyaret istatistikleri ve reklamlar için çerez kullanıyoruz.{" "}
          <span className="hidden text-foreground sm:inline">
            İşlediğiniz dosyalar bundan etkilenmez — onlar zaten cihazınızdan çıkmaz.
          </span>{" "}
          {/*
            prefetch={false}: banner ilk boyamada görünür olduğu için Next bu
            bağlantının hedefini hemen önceden indiriyordu — mobilde 53 KB, LCP
            ile aynı hat için yarışıyordu. Nadiren tıklanan bir bağlantı.
          */}
          <Link href="/cerez-politikasi" prefetch={false} className="text-brand underline underline-offset-2">
            Ayrıntılar
          </Link>
        </p>

        {/*
          İki düğme GÖRSEL OLARAK EŞİT ağırlıkta: AB mevzuatı reddetmeyi
          kabul etmek kadar kolay hâle getirmeyi şart koşar. "Reddet"i
          soluk bir bağlantı yapmak uyumsuzluk sayılır.
        */}
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => karar(false)}
            className="min-h-11 flex-1 rounded-xl border border-border px-5 text-sm font-semibold transition hover:bg-surface-muted sm:flex-none sm:py-2.5"
          >
            Reddet
          </button>
          <button
            type="button"
            onClick={() => karar(true)}
            className="min-h-11 flex-1 rounded-xl bg-brand px-5 text-sm font-semibold text-brand-fg transition hover:brightness-110 sm:flex-none sm:py-2.5"
          >
            Kabul et
          </button>
        </div>
      </div>
    </div>
  );
}
